import { render, staticRenderFns } from "./xhm.vue?vue&type=template&id=08294120&"
import script from "./xhm.vue?vue&type=script&lang=js&"
export * from "./xhm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports